var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.formLoading,
          expression: "formLoading",
        },
      ],
      staticClass: "coupon--datacontainer full-height",
      staticStyle: { padding: "10px" },
    },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _vm.travelID
          ? _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v("旅遊團-優惠票券維護")])]
            )
          : _vm._e(),
        _c(
          "div",
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "dynamicValidateForm",
                        attrs: {
                          model: _vm.formData,
                          "label-width": _vm.formLabelWidth,
                          "label-position": "right",
                          disabled: _vm.isReadMode,
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "票券名稱",
                              prop: "couponName",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入票券名稱",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "票券名稱" },
                              model: {
                                value: _vm.formData.couponName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "couponName", $$v)
                                },
                                expression: "formData.couponName",
                              },
                            }),
                          ],
                          1
                        ),
                        !_vm.agencyCode
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "使用位置",
                                  prop: "position",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入使用位置",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "使用位置" },
                                  model: {
                                    value: _vm.formData.position,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "position", $$v)
                                    },
                                    expression: "formData.position",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.agencyCode
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "連絡電話",
                                  prop: "couponPhone",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入連絡電話",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "連絡電話" },
                                  model: {
                                    value: _vm.formData.couponPhone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "couponPhone", $$v)
                                    },
                                    expression: "formData.couponPhone",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: "連結網址", prop: "link" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "連結網址" },
                              model: {
                                value: _vm.formData.link,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "link", $$v)
                                },
                                expression: "formData.link",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "狀態" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-text": "停用",
                                "inactive-text": "啟用",
                                "active-color": "#ff4949",
                                "inactive-color": "#13ce66",
                              },
                              model: {
                                value: _vm.formData.disabled,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "disabled", $$v)
                                },
                                expression: "formData.disabled",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "票券描述",
                              prop: "description",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入票券描述",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                autosize: { minRows: 6, maxRows: 8 },
                                type: "textarea",
                                placeholder: "票券描述",
                              },
                              model: {
                                value: _vm.formData.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "description", $$v)
                                },
                                expression: "formData.description",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "開放日期",
                              "label-width": _vm.formLabelWidth,
                              prop: "dateRange",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "至",
                                "value-format": "yyyy-MM-dd",
                                placeholder: "選擇日期",
                              },
                              on: { change: _vm.dateTrigger },
                              model: {
                                value: _vm.date,
                                callback: function ($$v) {
                                  _vm.date = $$v
                                },
                                expression: "date",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": _vm.formLabelWidth,
                          "label-position": "right",
                          disabled: _vm.isReadMode,
                        },
                      },
                      [
                        _vm.agencyCode
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "設定為問卷使用" } },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-text": "否",
                                    "inactive-text": "是",
                                    "active-color": "#ff4949",
                                    "inactive-color": "#13ce66",
                                    "active-value": false,
                                    "inactive-value": true,
                                  },
                                  model: {
                                    value: _vm.formData.showToSurvey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "showToSurvey",
                                        $$v
                                      )
                                    },
                                    expression: "formData.showToSurvey",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.formData.showToSurvey,
                                expression: "!formData.showToSurvey",
                              },
                            ],
                            attrs: {
                              label: "排序",
                              prop: "sort",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入排序",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input-number", {
                              attrs: { min: 1, label: "排序" },
                              model: {
                                value: _vm.formData.sort,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "sort", $$v)
                                },
                                expression: "formData.sort",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "票券圖",
                              "label-width": _vm.formLabelWidth,
                              rules: [
                                {
                                  required: true,
                                  message: "請上傳票券圖片",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _vm.formData.fileInfo
                              ? _c(
                                  "div",
                                  [
                                    _c("Upload", {
                                      ref: "uploadRef",
                                      attrs: {
                                        require: true,
                                        "limit-file-count": 1,
                                        payload: _vm.formData,
                                        accept: ".jpg,.jpeg,.png",
                                        "data-obj": _vm.fileObj,
                                        "use-drag": false,
                                        action: "Coupon/saveCoupon",
                                        "auto-upload": false,
                                        "show-file-list": true,
                                        "form-on-loading-parent":
                                          _vm.formLoading,
                                        "btn-txt": "上傳",
                                        "before-file-list":
                                          _vm.formData.fileInfo &&
                                          _vm.formData.fileInfo.length
                                            ? _vm.formData.fileInfo[0].files
                                            : [],
                                        limitText:
                                          "APP顯示圖片最佳尺寸為1000x1000大小，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                        !_vm.agencyCode
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "票券分類" } },
                              [
                                !_vm.categories || _vm.categories.length == 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          height: "auto",
                                          "white-space": "break-spaces",
                                          "font-size": "14px",
                                          cursor: "pointer",
                                        },
                                        attrs: { type: "warning" },
                                        on: { click: _vm.openUrl },
                                      },
                                      [
                                        _vm._v(
                                          "尚未建立分類，請點擊至【活動管理】>【票券管理】>【分類管理】建立分類"
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "warning",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addCate()
                                              },
                                            },
                                          },
                                          [_vm._v("新增")]
                                        ),
                                        _c("br"),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              height: "300px",
                                              border: "1px solid #ccc",
                                              padding: "5px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-table",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  data: _vm.formData
                                                    .couponCategories,
                                                  border: "",
                                                  size: "mini",
                                                  height: "100%",
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "層數",
                                                    width: "50",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  scope.$index +
                                                                    1
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    3056706777
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: { label: "分類" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "block",
                                                              },
                                                              [
                                                                _c(
                                                                  "el-cascader",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      props: {
                                                                        checkStrictly: true,
                                                                      },
                                                                      disabled:
                                                                        !_vm.categories ||
                                                                        _vm
                                                                          .categories
                                                                          .length ==
                                                                          0,
                                                                      placeholder:
                                                                        "請選擇",
                                                                      filterable:
                                                                        "",
                                                                      options:
                                                                        _vm.categories,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .selectedCategories,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "selectedCategories",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.selectedCategories",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    3401251735
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    align: "center",
                                                    label: "刪除",
                                                    width: "120",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-button",
                                                              {
                                                                attrs: {
                                                                  size: "mini",
                                                                  type: "danger",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.deleteCate(
                                                                        scope.row
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("刪除")]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    1391677539
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-top": "15px" } },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isReadMode,
                  expression: "!isReadMode",
                },
              ],
              staticStyle: { color: "#4b4b4b" },
              attrs: { type: "warning" },
              on: {
                click: function ($event) {
                  return _vm.saveData("dynamicValidateForm")
                },
              },
            },
            [_vm._v(" 儲 存 ")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.fatherDialogFormVisible(false)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.isReadMode ? "關 閉" : "取 消") + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }